import React from "react";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";

const AdminAuthGuard = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const secretKey = process.env.REACT_APP_USER_KEY;
  const data = localStorage.getItem("userData");
  let decryptedObject;
  if (data) {
    const bytes = CryptoJS.AES.decrypt(data, secretKey);
    const decryptedJsonString = bytes.toString(CryptoJS.enc.Utf8);
    decryptedObject = JSON.parse(decryptedJsonString);
  } else {
    console.error("No data found.");
  }

  const roleName = decryptedObject?.decoded?.RoleName;
  const hrmsDesignationName = decryptedObject?.decoded?.HrmsDesignationName?.toLowerCase();
  const permissionTypeName = decryptedObject?.decoded?.PermissionTypeName;
  const path = location.pathname;
  const isMentorAllowedAdminPath =
    path === "/admin/lms/addCourse" ||
    path === "/admin/lms/editCourse" ||
    /^\/admin\/lms\/all-techTalk\/[^/]+$/.test(path);

  const permissionArray = permissionTypeName?.split(",");
  let session;
  let review;
  let project;

  permissionArray?.forEach((element) => {
    if (element === "Session") session = true;
    if (element === "Project") project = true;
    if (element === "Review") review = true;
  });

  if (!localStorage.getItem("login") || localStorage.getItem("login") === "false") {
    return <Navigate to="/" replace />;
  }

  if (roleName === process.env.REACT_APP_USER_DES_ADMIN) {
    return <Outlet />;
  }

  if (roleName === process.env.REACT_APP_USER_DES_USER) {
    if (hrmsDesignationName === "sde" || hrmsDesignationName === "intern") {
      return <Navigate to="/dashboard" replace />;
    }

    return <Navigate to="/lms/dashboard" replace />;
  }

  if (roleName === process.env.REACT_APP_USER_DES_MENTOR) {
    if (isMentorAllowedAdminPath) {
      return <Outlet />;
    }

    return <Navigate to="/lms/dashboard" replace />;
  }

  if (path === "/lms/dashboard" && session) {
    return <Outlet />;
  }

  if (
    (path === "/lms/grade-assignment" || path === "/mentor/project-rating" || path === "/lms/grade-assignment/review-assignment-submission") &&
    (project || session)
  ) {
    return <Outlet />;
  }

  if (
    (path === "/mentor/review-associates" || path === "/mentor/review-associates/inter-performance-review") &&
    review
  ) {
    return <Outlet />;
  }

  if (session) return <Navigate to="/lms/dashboard" replace />;
  if (project) return <Navigate to="/lms/grade-assignment" replace />;
  if (review) return <Navigate to="/mentor/review-associates" replace />;

  return <Navigate to="/" replace />;
};

export default AdminAuthGuard;
